import { createSlice } from '@reduxjs/toolkit'

/**
 * State of the menu system in order to isolate UI changes comming from backend notifications.
 */
export const xeditor = createSlice({
    name: 'xeditor',
    initialState: {
        currentInstance: {id: '', needSave: false},
        saveEvent: {id: '', serial: 0, closeAfterSave: false, confirmAfterSave: true},
        closeEvent: {id: '', serial: 0, noCloseWindow: false},
        instances: [],
    },
    reducers: {
        addInstance: (state, action) => {
            const inst = action.payload;
            const instances = [ ...state.instances];
            const index = instances.findIndex( item => item.id === inst.id);
            if ( index >= 0 ) {
                instances[index] = inst;
            } else {
                instances.push(inst);                
            }
            state.instances = instances;
            state.currentInstance = inst;
            // console.log('Setting currentInstances = ' + JSON.stringify(state.instances));
        },
        removeInstance: (state, action) => {
            const inst = action.payload;
            const instances = [ ...state.instances];
            const index = instances.findIndex( item => item.id === inst.id);
            if ( index >= 0 ) {
                instances.splice(index, 1);
                console.log('cinst = ' + state.currentInstance?.id);
                const cinst = state.currentInstance?.id ? instances.find( item => item.id === state.currentInstance.id) : null;
                if ( !cinst ) {
                    let ninst = state.currentInstance;
                    if (index < instances.length) {
                        ninst = instances[index];
                    } else if ( index - 1 >= 0 ) {
                        ninst = instances[index-1];
                    } else if (state.instances.length > 0) {
                        ninst = instances[0];
                    }
                    console.log('ninst = ' + ninst.id);
                    state.currentInstance = ninst;
                }
                state.instances = instances;
            }
        },
        setCurrentInstance: (state, action) => {
            state.currentInstance = action.payload;
        },

        resetInstances: (state) => {
            state.instances = [];
            state.saveEvent = {id: '', serial: 0};
            state.currentInstance = {id: '', needSave: false};
        },
        saveAction: (state, action) => {
            let serial = state.saveEvent.serial;
            if ( !serial ) {
                serial = 1;
            } else {
                serial += 1;
            }
            
            const event = action.payload;
            event.serial = serial;
            state.saveEvent = event;
        },
        closeAction: (state, action) => {
            let serial = state.closeEvent.serial;
            if ( !serial ) {
                serial = 1;
            } else {
                serial += 1;
            }
            const event = action.payload;
            event.serial = serial;
            state.closeEvent = event;
        }
    },
});

/*
export const workfront = createSlice({
    name: 'workfront',
    initialState: {
        listValue: true,
        showList: true,
        instanceValue: false,
        showInstance: false,
        instanceNode: null,
        expandedKeys: {},
    },
    reducers: {
        setWorkList: (state, action) => {
            state.showList = action.payload.showList;
            state.listValue = action.payload.listValue;
            // console.log('Setting currentMenu = ' + action.payload + ', pageIndex = ' + state.pageIndex);
        },
        setWorkInstance: (state, action) => {
            state.showInstance = action.payload.showInstance;
            state.instanceValue = action.payload.instanceValue;
            
            // onsole.log('Setting pageIndex = ' + action.payload + ', currentMenu = ' + state.currentMenu);
        },
        setWorkNode: (state,action) => {
            state.instanceNode = action.payload
        },
        setExpandedKeys: (state,action) => {
            state.expandedKeys = action.payload
        },
    },
});

// same as workfront but for Runtime management
export const runtime = createSlice({
    name: 'runtime',
    initialState: {
        listValue: true,
        showList: true,
        instanceValue: false,
        showInstance: false,
        instanceNode: null,
        expandedKeys: {},
    },
    reducers: {
        setRuntimeList: (state, action) => {
            state.showList = action.payload.showList;
            state.listValue = action.payload.listValue;
            // console.log('Setting currentMenu = ' + action.payload + ', pageIndex = ' + state.pageIndex);
        },
        setRuntimeInstance: (state, action) => {
            state.showInstance = action.payload.showInstance;
            state.instanceValue = action.payload.instanceValue;
            
            // onsole.log('Setting pageIndex = ' + action.payload + ', currentMenu = ' + state.currentMenu);
        },
        setRuntimeNode: (state,action) => {
            state.instanceNode = action.payload
        },
        setRuntimeExpandedKeys: (state,action) => {
            state.expandedKeys = action.payload
        },
    },
});

// to control popup of some step actions
export const stepaction = createSlice({
    name: 'stepaction',
    initialState: {
        // after setting up action buttons, automatically open next or previous action
        openNextStep: false,
        // current action that triggered the state change
        openStepAction: null,
        openWorkflowId: -1,
        // current step that triggered the state change
        // openStepId: -1,
    },
    reducers: {
        setOpenNextStep: (state,action) => {
            if ( action.payload.openNextStep !== state.openNextStep ) {
                state.openNextStep = action.payload.openNextStep;
            }
            if ( action.payload.openStepAction !== state.openStepAction ) {
                state.openStepAction = action.payload.openStepAction;
            }
            if ( action.payload.openWorkflowId !== state.openWorkflowId ) {
                state.openWorkflowId = action.payload.openWorkflowId;
            }
            // state.openStepId = action.payload.openStepId;
        },
    },
});

export const { setCurrentMenu, setPageIndex, setPageName } = menu.actions;
export const { setWorkInstance, setWorkList, setWorkNode, setExpandedKeys } = workfront.actions;
export const { setRuntimeInstance, setRuntimeList, setRuntimeNode, setRuntimeExpandedKeys } = runtime.actions;
export const { setOpenNextStep } = stepaction.actions;
*/
export const { addInstance, removeInstance, saveAction, closeAction, resetInstances, setCurrentInstance } = xeditor.actions;